import styled from '@emotion/styled';
// 태그 관련 스타일
export const TagListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  overflow: hidden;
`;
export const TagItem = styled.span`
  display: inline-block;
  padding: 2px 8px;
  background-color: var(--theme-paper-light);
  color: var(--theme-text-secondary);
  border-radius: 4px;
  font-size: 0.75rem;
  line-height: 1.4;
  white-space: nowrap;

  @media (max-width: 400px) {
    font-size: 0.7rem;
    padding: 2px 6px;
  }
  @media (max-width: 350px) {
    font-size: 0.65rem;
    padding: 1px 4px;
  }
`;
// 평점 관련 스타일
export const RatingWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  color: var(--theme-text-muted);

  @media (max-width: 350px) {
    font-size: 0.65rem;
  }
`;
export const StarIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 2px;

  svg {
    width: 14px;
    height: 14px;
    color: #f59e0b;
    fill: #f59e0b;
  }

  @media (max-width: 350px) {
    margin-right: 1px;
    
    svg {
      width: 12px;
      height: 12px;
    }
  }
`;
// 레벨 관련 스타일
export const LevelIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 0.75rem;
  color: var(--theme-text-muted);
  white-space: nowrap;

  @media (max-width: 350px) {
    font-size: 0.65rem;
  }
`;
export const LevelInfoIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;

  svg {
    width: 14px;
    height: 14px;
    color: var(--theme-text-muted);
  }

  @media (max-width: 350px) {
    margin-left: 2px;
    
    svg {
      width: 12px;
      height: 12px;
    }
  }
`;
// 수강생 관련 스타일
export const EnrollmentWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  color: var(--theme-text-muted);

  @media (max-width: 350px) {
    font-size: 0.65rem;
  }
`;
export const UsersIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 3px;

  svg {
    width: 14px;
    height: 14px;
    color: var(--theme-text-muted);
  }

  @media (max-width: 350px) {
    margin-right: 2px;
    
    svg {
      width: 12px;
      height: 12px;
    }
  }
`;
// 진행률 관련 스타일
export const ProgressWrapper = styled.div`
  font-size: 0.75rem;
  color: var(--theme-success);
  font-weight: 500;

  @media (max-width: 350px) {
    font-size: 0.7rem;
  }
`;
// 완료 배지 스타일
export const CompletedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background-color: var(--theme-completed-badge-bg-light, #eff6ff);
  color: var(--theme-completed-badge-text-light, #2563eb);
  html.dark &, body.vscode-dark & {
    background-color: var(--theme-completed-badge-bg-dark, #1e40af);
    color: var(--theme-completed-badge-text-dark, #dbeafe);
  }
  font-size: 0.7rem;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;

  @media (max-width: 350px) {
    font-size: 0.65rem;
    padding: 1px 4px;
  }
`;
export const CompletedIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 3px;

  svg {
    width: 12px;
    height: 12px;
  }

  @media (max-width: 350px) {
    margin-right: 2px;
    
    svg {
      width: 10px;
      height: 10px;
    }
  }
`;
// 수강 중 배지 스타일
export const EnrolledBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background-color: var(--theme-enrolled-badge-bg-light, #ecfdf5);
  color: var(--theme-enrolled-badge-text-light, #059669);
  html.dark &, body.vscode-dark & {
    background-color: var(--theme-enrolled-badge-bg-dark, #065f46);
    color: var(--theme-enrolled-badge-text-dark, #a7f3d0);
  }
  font-size: 0.7rem;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;

  @media (max-width: 350px) {
    font-size: 0.65rem;
    padding: 1px 4px;
  }
`;
export const EnrolledIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 3px;

  svg {
    width: 12px;
    height: 12px;
  }

  @media (max-width: 350px) {
    margin-right: 2px;
    
    svg {
      width: 10px;
      height: 10px;
    }
  }
`;
// 가격 관련 스타일
export const PriceWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  font-size: 0.875rem;
  font-weight: bold;
  color: var(--theme-text);

  @media (max-width: 350px) {
    font-size: 0.8rem;
    gap: 2px;
  }
`;
export const OriginalPrice = styled.span`
  font-size: 0.75rem;
  color: var(--theme-text-muted);
  text-decoration: line-through;

  @media (max-width: 350px) {
    font-size: 0.7rem;
  }
`;
export const DiscountedPrice = styled.span`
  // 특별한 스타일 필요 시 추가 (기본은 PriceWrapper 스타일 따름)
`;
export const FreeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background-color: var(--theme-free-badge-bg-light, #f0fdf4);
  color: var(--theme-free-badge-text-light, #16a34a);
  html.dark &, body.vscode-dark & {
    background-color: var(--theme-free-badge-bg-dark, #166534);
    color: var(--theme-free-badge-text-dark, #bbf7d0);
  }
  font-size: 0.75rem;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;

  @media (max-width: 350px) {
    font-size: 0.7rem;
    padding: 1px 4px;
  }
`;
export const GiftIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 3px;

  svg {
    width: 12px;
    height: 12px;
  }

  @media (max-width: 350px) {
    margin-right: 2px;
    
    svg {
      width: 10px;
      height: 10px;
    }
  }
`;
// 언어 지원 관련 스타일
export const LanguageSupport = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.72rem;
  color: var(--theme-text-secondary);
  background-color: var(--theme-chip-bg, rgba(148, 163, 184, 0.12));
  border: 1px solid var(--theme-border-light, rgba(148, 163, 184, 0.35));
  border-radius: 9999px;
  padding: 2px 10px 2px 8px;
  white-space: nowrap;

  @media (max-width: 350px) {
    font-size: 0.65rem;
    padding: 1px 8px 1px 6px;
    gap: 4px;
  }
`;
export const GlobeIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 12px;
    height: 12px;
    color: var(--theme-text-muted);
  }

  @media (max-width: 350px) {
    svg {
      width: 10px;
      height: 10px;
    }
  }
`;
export const LanguageFlags = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;
export const LanguageBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 9999px;
  background-color: var(--theme-chip-pill-bg, rgba(148, 163, 184, 0.2));
  color: var(--theme-text, #0f172a);
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;

  @media (max-width: 350px) {
    font-size: 0.62rem;
    padding: 1px 5px;
  }
`;
export const MoreLanguagesBadge = styled(LanguageBadge)`
  background-color: var(--theme-chip-pill-accent-bg, rgba(59, 130, 246, 0.18));
  color: var(--theme-primary, #2563eb);
`;
// 강사 배지 스타일 (내 강의)
export const InstructorBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background-color: var(--theme-instructor-badge-bg-light, #f3e8ff);
  color: var(--theme-instructor-badge-text-light, #7c3aed);
  html.dark &, body.vscode-dark & {
    background-color: var(--theme-instructor-badge-bg-dark, #5b21b6);
    color: var(--theme-instructor-badge-text-dark, #e9d5ff);
  }
  font-size: 0.7rem;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;

  @media (max-width: 350px) {
    font-size: 0.65rem;
    padding: 1px 4px;
  }
`;
export const InstructorIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 3px;

  svg {
    width: 12px;
    height: 12px;
  }

  @media (max-width: 350px) {
    margin-right: 2px;

    svg {
      width: 10px;
      height: 10px;
    }
  }
`;
// 발행 상태 배지 스타일
export const PublishStatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background-color: ${(props)=>props.isPublished ? 'var(--theme-published-badge-bg-light, #f0fdf4)' : 'var(--theme-unpublished-badge-bg-light, #fef3c7)'};
  color: ${(props)=>props.isPublished ? 'var(--theme-published-badge-text-light, #16a34a)' : 'var(--theme-unpublished-badge-text-light, #d97706)'};
  html.dark &, body.vscode-dark & {
    background-color: ${(props)=>props.isPublished ? 'var(--theme-published-badge-bg-dark, #166534)' : 'var(--theme-unpublished-badge-bg-dark, #92400e)'};
    color: ${(props)=>props.isPublished ? 'var(--theme-published-badge-text-dark, #bbf7d0)' : 'var(--theme-unpublished-badge-text-dark, #fde68a)'};
  }
  font-size: 0.7rem;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;

  @media (max-width: 350px) {
    font-size: 0.65rem;
    padding: 1px 4px;
  }
`;
export const PublishStatusIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 3px;

  svg {
    width: 12px;
    height: 12px;
  }

  @media (max-width: 350px) {
    margin-right: 2px;

    svg {
      width: 10px;
      height: 10px;
    }
  }
`;
